<template>
  <div class="main-banner jarallax" data-jarallax="{'speed': 0.3}">
    <div class="d-table">
      <div class="d-table-cell">
        <div class="container">
          <div class="main-banner-content">
            <h1>IRecharge Pay</h1>
            <p align="left">
              
            </p>
            <a target="_blank" href="https://irecharge.com.ng/#/irecharge_merchant" class="btn btn-primary btn-animate">Become A Merchant</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>

<style scoped>
  
</style>